import { Color } from '@billy/design-system'
import { StyleSheet } from '@react-pdf/renderer'
import type { Style } from '@react-pdf/types'

interface GetTableRowCellPdfStylesProps {
  minWidth?: number
  shouldHaveLastColumnStyles: boolean
}

export const getTableRowCellPdfStyles = ({
  minWidth,
  shouldHaveLastColumnStyles,
}: GetTableRowCellPdfStylesProps): Style => {
  const pdfStyles = StyleSheet.create({
    tableRowCell: {
      minWidth: minWidth || 'auto',
      padding: 12,
      borderBottomWidth: 1,
      ...(shouldHaveLastColumnStyles && { borderRightWidth: 1, textAlign: 'right' }),
      borderColor: Color.Grey200,
      flex: 1,
      flexWrap: 'wrap',
      wordBreak: 'break-word',
    },
  })

  return pdfStyles.tableRowCell
}
